import axios from "axios";

import store from "@/store";

import { getFullUrl } from "../utilities/utils";

/**
 * Retrieves data using the GET method.
 *
 * @param {object} request - The request object containing the URL, method, and parameters.
 * @return {Promise} A Promise that resolves with the fetched data.
 */
export const get = (request) => {
  return commonFetch({
    url: request.url ? request.url : getFullUrl(request.endPoint),
    method: "GET",
    params: request.params || {},
  });
};

/**
 * Sends a POST request using commonFetch with the specified URL, data, and headers.
 *
 * @param {Object} request - The request object containing the URL, data, and headers.
 * @return {Promise} A Promise that resolves with the response data from the server.
 */
export const post = (request) => {
  return commonFetch({
    url: getFullUrl(request.endPoint),
    method: "POST",
    data:
      request.data instanceof FormData
        ? request.data
        : {
            ...request.data,
          },
    headers: request.headers || {},
  });
};

// const getRandom = () => {
//   return Math.floor(100000 + Math.random() * 900000);
// };

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger

    // Uncomment below code to decrypt the response data
    // response = {
    //   ...response,
    //   data: JSON.parse(apiDecrypt(response.data)),
    // }

    if (response.data.success === 0) {
      let data = {
        ...response,
        response: {
          ...response.response,
          data: {
            data: {},
            message: response.data.error,
          },
          status: response.status,
        },
      };
      return Promise.reject(data);
    }
    let data = {
      ...response,
      data: {
        ...response.data.data,
      },
    };
    return data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (error.status === 419 || error.status === 401) {
      window.location.href = "/logout";
    }

    // Silently suppress 404 (API endpoint not found) errors
    if (error?.response?.status === 404) {
      return Promise.reject({
        ...error,
        response: {
          ...error.response,
          data: { data: {}, message: "" },
        },
        _suppressed404: true,
      });
    }

    let data = {
      ...error,
      response: {
        ...error.response,
        data: {
          data: {},
          message:
            error?.response?.data?.error ||
            error?.message ||
            "Something went wrong. Please try again.",
        },
      },
    };
    return Promise.reject(data);
  },
);

export const postFormData = async (endPoint, formData) => {
  let session = store.getState().session.session;
  let extraHeaders = {
    Accept: "application/json",
    Authorization: `Bearer ${session.user_token}`,
  };
  return axios
    .post(getFullUrl(endPoint), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...extraHeaders,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};

/**
 * Asynchronous function to perform a common fetch operation with the given request parameters.
 *
 * @param {Object} request - The request object containing URL, headers, method, data, and params.
 * @return {Promise} A Promise that resolves with the response data or rejects with an error.
 */
const commonFetch = async (request) => {
  let session = store.getState().session.session;
  let isLoggedin =
    session?.user_token && session?.user_id && session?.user_type;
  let requestData = request.data; // for POST
  let extraHeaders = {};
  let requestParams = request.params; // for GET
  if (isLoggedin) {
    let user = {
      id: session.user_id,
      type: session.user_type,
      login_user_token: session.user_token,
    };
    if (request.method === "GET") {
      requestParams = {
        ...requestParams,
        user,
      };
    } else {
      if (requestData instanceof FormData) {
        requestData.append("user[id]", session.user_id);
        requestData.append("user[type]", session.user_type);
        requestData.append("user[login_user_token]", session.user_token);
      } else {
        requestData = {
          ...requestData,
          user,
        };
      }
    }
    extraHeaders = {
      Accept: "application/json",
      Authorization: `Bearer ${session.user_token}`,
    };
  }
  // Object.keys(requestData).forEach((key) => {
  //   let value = requestData[key];
  //   if (typeof value === "object") {
  //     value = JSON.stringify(value);
  //   }
  //   if(value == 0){
  //     requestData[`___${key}`] = value;
  //     requestData[key] = apiEncrypt(value);
  //   } else if(value == null || value == undefined || value == 'undefined' || value == 'null' || value == '') {
  //     requestData[key] = '';
  //   } else {
  //     requestData[`___${key}`] = value;
  //     requestData[key] = apiEncrypt(value);
  //   }
  // })

  // requestData = {
  //   data: apiEncrypt(JSON.stringify(requestData)),
  // }
  return axios({
    url: request.url,
    headers: {
      // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      ...(requestData instanceof FormData
        ? {}
        : { "Content-Type": "application/x-www-form-urlencoded" }),
      ...request.headers,
      // "Access-Control-Allow-Origin": "*",
      // "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
      ...extraHeaders,
    },
    method: request.method,
    data: requestData,
    params: request.params,
  })
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((error) => {
      // if (error.name === "CanceledError") {
      //   // console.log('request canceled', error);
      //   return Promise.reject(error);
      // }
      // const {
      //   response: {
      //     status,
      //     data: { message },
      //   },
      // } = error;
      // // console.log("error", error);
      // if (status === 419 || status === 401) {
      //   return Promise.reject(error);
      // } else if (status === 405) {
      //   let obj = {
      //     message: message,
      //     status: status,
      //   };
      //   // console.error(obj);
      // } else {
      //   return Promise.reject(error);
      // }

      //   if (error?.name === "CanceledError") {
      //   return Promise.reject(error);
      // }

      const status = error?.response?.status;

      if (status === 419 || status === 401) {
        return Promise.reject(error);
      } else if (status === 405) {
        // handle 405
      } else {
        return Promise.reject(error);
      }
    });
};
